export enum FilterOption {
  OLDEST_TO_NEWEST = 'Oldest to Newest',
  LATEST_CREATED = 'Newest to Oldest',
  LAST_USED = 'Last Used',
}

export enum SnippetCountActions {
  INCREMENT = 'increment',
  DECREMENT = 'decrement',
}

export const SNIPPET_FILTER_LABELS = [
  FilterOption.LATEST_CREATED,
  FilterOption.OLDEST_TO_NEWEST,
  FilterOption.LAST_USED,
]
export const INSERT_SNIPPET = 'insertSnippet'
export const SNIPPET_DATA = 'snippetData'
export const SHOW_SNIPPET_PREVIEW = 'showSnippetPreview'
export const REMOVE_SNIPPET_PREVIEW = 'removeSnippetPreview'
export const $FROM = '$from'
